export const IMAGE_SEARCH_PATENT_TYPE = {
    design: 'D',
    utilityModels: 'U',
};
